var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleCoin = function SvgCircleCoin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4.5 12c0 6.15 6.667 9.993 12 6.918a7.99 7.99 0 0 0 4-6.918c0-6.15-6.667-9.992-12-6.918A7.99 7.99 0 0 0 4.5 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.297 9a2 2 0 0 0-1.798-.999h-1.998c-1.538 0-2.5 1.666-1.73 3 .356.618 1.016.999 1.73.999h1.998c1.538 0 2.5 1.666 1.73 3-.357.618-1.016.999-1.73.999h-1.998a2 2 0 0 1-1.798-1M12.5 6.487v11.025"
  })));
};
export { SvgCircleCoin as ReactComponent };
export default __webpack_public_path__ + "0bd82fe5c39f69e00b1405e89a0d5e34.svg";